import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { admin, adminRoute, canRoute, candidate, empRoute, employer, publicUser } from "../../../globals/route-names";
import { useAuth } from "../../../context/AuthContext";

function SignUpPopup() {
    const navigate = useNavigate();
    const { register } = useAuth();
    const [activeRole, setActiveRole] = useState("candidate");
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: "",
        agree: false
    });
    const [visible, setVisible] = useState({
        password: false,
        confirmPassword: false
    });
    const [status, setStatus] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const update = (event) => {
        const { name, value, checked, type } = event.target;
        setForm((current) => ({
            ...current,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const destinationFor = (user) => {
        if (user.role === "admin") return adminRoute(admin.DASHBOARD);
        if (user.role === "employer") return empRoute(employer.DASHBOARD);
        return canRoute(candidate.DASHBOARD);
    };

    const closePopup = () => {
        const element = document.getElementById("sign_up_popup");
        const modal = window.bootstrap?.Modal?.getInstance(element);
        modal?.hide();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setStatus("");

        if (!form.agree) {
            setStatus("Please accept the terms and conditions.");
            return;
        }
        if (form.password.length < 6) {
            setStatus("Password must be at least 6 characters.");
            return;
        }
        if (form.password !== form.confirmPassword) {
            setStatus("Passwords do not match. Please re-enter the same password.");
            return;
        }
        setSubmitting(true);
        try {
            const user = await register({
                name: form.name,
                email: form.email,
                password: form.password,
                phone: form.phone,
                role: activeRole
            });
            closePopup();
            navigate(destinationFor(user));
        } catch (error) {
            setStatus(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="modal fade twm-sign-up" id="sign_up_popup" aria-hidden="true" aria-labelledby="sign_up_popupLabel" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h2 className="modal-title" id="sign_up_popupLabel">Sign Up</h2>
                                <p>Sign Up and get access to all the features of Jobzilla</p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="twm-tabs-style-2">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        {/*Signup Candidate*/}
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#sign-candidate" type="button" onClick={() => setActiveRole("candidate")}><i className="fas fa-user-tie" />Candidate</button>
                                        </li>
                                        {/*Signup Employer*/}
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" data-bs-toggle="tab" data-bs-target="#sign-Employer" type="button" onClick={() => setActiveRole("employer")}><i className="fas fa-building" />Employer</button>
                                        </li>
                                    </ul>
                                    {status && <div className="alert alert-danger m-t20">{status}</div>}
                                    <div className="tab-content" id="myTabContent">
                                        {/*Signup Candidate Content*/}
                                        <div className="tab-pane fade show active" id="sign-candidate">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <input name="name" type="text" required className="form-control" placeholder="Full name*" value={form.name} onChange={update} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <input name="email" type="email" className="form-control" required placeholder="Email*" value={form.email} onChange={update} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <PasswordField name="password" placeholder="Password*" value={form.password} onChange={update} visible={visible.password} onToggle={() => setVisible({ ...visible, password: !visible.password })} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <PasswordField name="confirmPassword" placeholder="Re-enter password*" value={form.confirmPassword} onChange={update} visible={visible.confirmPassword} onToggle={() => setVisible({ ...visible, confirmPassword: !visible.confirmPassword })} />
                                                        <PasswordMatch password={form.password} confirmPassword={form.confirmPassword} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <input name="phone" type="text" className="form-control" placeholder="Phone" value={form.phone} onChange={update} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <div className=" form-check">
                                                            <input type="checkbox" name="agree" className="form-check-input" id="agree1" checked={form.agree} onChange={update} />
                                                            <label className="form-check-label" htmlFor="agree1">I agree to the <NavLink to={publicUser.pages.FAQ} onClick={closePopup}>Terms and conditions</NavLink></label>
                                                            <p>Already registered?
                                                                <button type="button" className="twm-backto-login" data-bs-target="#sign_up_popup2" data-bs-toggle="modal" data-bs-dismiss="modal">Log in here</button>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <button type="submit" className="site-button" disabled={submitting}>{submitting ? "Creating account..." : "Sign Up"}</button>
                                                </div>
                                            </div>
                                        </div>
                                        {/*Signup Employer Content*/}
                                        <div className="tab-pane fade" id="sign-Employer">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <input name="name" type="text" required className="form-control" placeholder="Company or contact name*" value={form.name} onChange={update} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <input name="email" type="email" className="form-control" required placeholder="Email*" value={form.email} onChange={update} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <PasswordField name="password" placeholder="Password*" value={form.password} onChange={update} visible={visible.password} onToggle={() => setVisible({ ...visible, password: !visible.password })} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <PasswordField name="confirmPassword" placeholder="Re-enter password*" value={form.confirmPassword} onChange={update} visible={visible.confirmPassword} onToggle={() => setVisible({ ...visible, confirmPassword: !visible.confirmPassword })} />
                                                        <PasswordMatch password={form.password} confirmPassword={form.confirmPassword} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <input name="phone" type="text" className="form-control" placeholder="Phone" value={form.phone} onChange={update} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <div className=" form-check">
                                                            <input type="checkbox" name="agree" className="form-check-input" id="agree2" checked={form.agree} onChange={update} />
                                                            <label className="form-check-label" htmlFor="agree2">I agree to the <NavLink to={publicUser.pages.FAQ} onClick={closePopup}>Terms and conditions</NavLink></label>
                                                            <p>Already registered?
                                                                <button type="button" className="twm-backto-login" data-bs-target="#sign_up_popup2" data-bs-toggle="modal" data-bs-dismiss="modal">Log in here</button>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <button type="submit" className="site-button" disabled={submitting}>{submitting ? "Creating account..." : "Sign Up"}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <span className="modal-f-title">Login or Sign up with</span>
                                <ul className="twm-modal-social">
                                    <li><a href="https://www.facebook.com/" className="facebook-clr"><i className="fab fa-facebook-f" /></a></li>
                                    <li><a href="https://www.twitter.com/" className="twitter-clr"><i className="fab fa-twitter" /></a></li>
                                    <li><a href="https://in.linkedin.com/" className="linkedin-clr"><i className="fab fa-linkedin-in" /></a></li>
                                    <li><a href="https://www.google.com/" className="google-clr"><i className="fab fa-google" /></a></li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}

function PasswordField({ name, placeholder, value, onChange, visible, onToggle }) {
    return (
        <div className="position-relative">
            <input
                name={name}
                type={visible ? "text" : "password"}
                className="form-control"
                required
                minLength={6}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={{ paddingRight: 44 }}
            />
            <button
                type="button"
                className="btn btn-link position-absolute top-50 end-0 translate-middle-y text-muted"
                onClick={onToggle}
                aria-label={visible ? "Hide password" : "Show password"}
            >
                <i className={visible ? "fa fa-eye-slash" : "fa fa-eye"} />
            </button>
        </div>
    );
}

function PasswordMatch({ password, confirmPassword }) {
    if (!confirmPassword) return <small className="text-muted">Re-enter your password to confirm.</small>;
    if (password === confirmPassword) return <small className="text-success">Passwords match.</small>;
    return <small className="text-danger">Passwords do not match.</small>;
}

export default SignUpPopup;
